import { TeamInfo } from '@/types';
import { STATES, type SwrState } from '@/utils/swr';

type TeamProfileAccess = Pick<TeamInfo, 'enable_profile'>;

export type InsightsAccess = 'pending' | 'allowed' | 'denied';

export const resolveInsightsAccess = (
  state: SwrState,
  teamInfo: TeamProfileAccess | undefined,
): InsightsAccess => {
  if (state === STATES.ERROR) return 'denied';
  if (teamInfo === undefined) return 'pending';

  return teamInfo.enable_profile ? 'allowed' : 'denied';
};
